module.exports = __webpack_public_path__ + "static/mariusz-tlo.80d96d35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/universal/img/mariusz-tlo.jpg
// module id = 824
// module chunks = 168707334958949